import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Lang } from 'src/app/models';
import { ApiProductsService, ApiSubscriptionsService, DatetimeService, LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { ApiMainSettingsService } from 'src/app/services/api-main-settings.service';
import { PresetValidator } from '../../presets/preset-create/preset-create.validators';

@Component({
  selector: 'app-subscriptions-create',
  templateUrl: './subscriptions-create.component.html',
  styleUrls: ['./subscriptions-create.component.css']
})
export class SubscriptionsCreateComponent implements OnInit {

  progressRef: NgProgressRef;
  apiSettings: ApiMainSettingsService;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  attributeName: Lang;
  ffInputLang: any = { name: '', valid: false };
  serviceItems:any[] = [];
  types:any[] = [];


  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    name: [null],
    discription: [null],
    type: [null],
    start_date: [null],
    end_date: [null],
    services: this.fb.array([])
  });


  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiSubscriptionService: ApiSubscriptionsService,
    private notification: NotificationService,
    private validator: PresetValidator,
    private router: Router,
    private validatorService: ValidatorsService,
    private datetimeService: DatetimeService
  ) { }

  ngOnInit(): void {

    this.addServiceFields();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  
  /**
   * 
   * @param fieldName 
   * @param value 
   */
  eventFnFF(fieldName: string, value: any): void {

    this.ffInputLang = value;

    this.form.controls[fieldName].setValue(value.name);
  }

  /**
   * 
   * @returns 
   */
  initConditionsFields(): any {

    return this.fb.group({
      service_id: [null],
      amount: [null],
      cost: [null]
    });
  }

  /**
   * 
   * @param type string
   */
  addServiceFields(): void {

    let control = this.form.controls.services as UntypedFormArray;
    control.push(this.initConditionsFields());
  }

  /**
   * 
   * @param i number
   */
  removeServiceField(i: number): void {

    let control = this.form.controls.services as UntypedFormArray;
    control.removeAt(i);
  }

  /**
   * 
   */
  onCreate(): void {

    // let data = this.form.value;

    // data.start_date = this.datetimeService.convertDateForDB(data.start_date);
    // console.log("FORM: ", data);
    

    // let selectors = {};

    // for (let s of this.form.controls.selectors.value) {
    //   selectors[s.attribute_id] = s.attribute_value;
    // }

    // let params = {
    //   id: this.form.controls.id.value,
    //   org_id: this.form.controls.org_id.value,
    //   name: this.form.controls.name.value,
    //   type: this.form.controls.type.value,
    //   conditional: this.form.controls.conditional.value,
    //   selectors: selectors,
    //   attrs_presets_content: this.form.controls.attrs_presets_content.value
    // }

    // this.progressRef.start();

    // this.subscriptions.add(
    //   this.apiPresets.create(data).subscribe((response: Res) => {
    //     console.log('[RESPONSE] CREATE PRESET: ', response);

    //     if (response != null) {


    //       this.notification.show('success', 'Данные успешно сохранены!');
    //     }

    //     this.progressRef.complete();
    //   },
    //     error => {
    //       this.progressRef.complete();
    //     })
    // );
  }

  backTo () {
  
        
    this.router.navigate(['settings']);
  
    // setTimeout(()=> this.apiSettings.switchTab('attributes'),1000)
    
  
  }
}
